export default __webpack_public_path__ + "static/Bakeryswap-bw-5-1b816ca3c1ca36209facaf4e454ee6e1.svg";